import { isPlatformBrowser } from '@angular/common';
import { AfterContentChecked, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
declare var AOS: any;

@Component({
  selector: 'app-talk-to-our-experts',
  templateUrl: './talk-to-our-experts.component.html',
  styleUrls: ['./talk-to-our-experts.component.css']
})
export class TalkToOurExpertsComponent implements OnInit, AfterContentChecked {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
      AOS.init();
    }
  }
  ngAfterContentChecked() {
    if (isPlatformBrowser(this.platformId)) {
      AOS.refresh();
    }
  }
}
